// Versão: 1.00
// Data..: 2026-09-24
// Botão de ligar (click-to-call). Abre um link tel: para o app 3CX Desktop discar
// o número/ramal. Se um ticketId for informado, registra o vínculo da ligação com o
// chamado (nota interna) — respeitando o interruptor de configuração no backend.

import { useState } from 'react';
import { api } from '../lib/api.js';

// Normaliza o destino para uso em tel:. Mantém apenas dígitos e um eventual "+"
// inicial (DDI). Ramais internos (poucos dígitos) também funcionam.
export function telHref(raw: string): string {
  const trimmed = (raw ?? '').trim();
  const plus = trimmed.startsWith('+') ? '+' : '';
  const digits = trimmed.replace(/\D/g, '');
  return `tel:${plus}${digits}`;
}

interface CallButtonProps {
  number: string; // número ou ramal a discar
  ticketId?: string; // se informado, registra a ligação no chamado
  contactName?: string; // nome de quem está do outro lado (para a nota)
  direction?: 'inbound' | 'outbound'; // padrão: outbound (nós ligamos)
  label?: string; // rótulo opcional ao lado do ícone
  title?: string; // tooltip
  className?: string; // classes extras do botão
}

export function CallButton({
  number,
  ticketId,
  contactName,
  direction = 'outbound',
  label,
  title,
  className,
}: CallButtonProps) {
  const [busy, setBusy] = useState(false);
  const digits = (number ?? '').replace(/\D/g, '');
  if (!digits) return null;

  const onClick = async () => {
    setBusy(true);
    try {
      // Dispara a ligação no app 3CX (handler do protocolo tel:).
      window.location.href = telHref(number);
      // Registra o vínculo com o chamado (best-effort; não bloqueia a ligação).
      if (ticketId) {
        await api
          .post(`/tickets/${ticketId}/call-log`, { destination: digits, direction, contactName })
          .catch(() => undefined);
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      className={className ?? 'btn btn-sm btn-ghost'}
      onClick={onClick}
      disabled={busy}
      title={title ?? `Ligar para ${number}`}
      aria-label={`Ligar para ${number}`}
    >
      📞{label ? ` ${label}` : ''}
    </button>
  );
}
